require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-announces-new-branch-bringing-financial-wellness-to.json") })
        }
      }, "path---es-articles-financial-center-announces-new-branch-bringing-financial-wellness-to");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-announces-new-branch-bringing-financial-wellness-to!./.cache/json/es-articles-financial-center-announces-new-branch-bringing-financial-wellness-to.json
// module id = 2101
// module chunks = 231608221292675